import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "nativewind/jsx-runtime";
import { SccButton } from '@/components/atoms';
import { SafeAreaWrapper } from '@/components/SafeAreaWrapper';
import { font } from '@/constant/font';
import ToastUtils from '@/utils/ToastUtils';
import { useFormContext } from 'react-hook-form';
import { ScrollView, View } from 'react-native';
import styled from 'styled-components/native';
import PlaceInfoSection from '../../PlaceReviewFormScreen/sections/PlaceInfoSection';
import { FORM_TOAST_OPTIONS } from '../constants';
import { QuestionSection, QuestionText, SectionLabel, SectionSeparator, SubmitButtonWrapper, } from '../PlaceFormV2Screen';
import FloorQuestionUI from './FloorQuestionUI';
export default function FloorStep({ place, onNext }) {
    const form = useFormContext();
    const selectedOption = form.watch('floorOption');
    const selectedFloor = form.watch('selectedFloor');
    const selectedStandaloneType = form.watch('standaloneType');
    const noticeError = (errorKey) => {
        switch (errorKey) {
            case 'floorOption':
                ToastUtils.show('층 정보를 선택해주세요.', FORM_TOAST_OPTIONS);
                break;
            case 'standaloneType':
                ToastUtils.show('단독건물 유형을 선택해주세요.', FORM_TOAST_OPTIONS);
                break;
            default:
                ToastUtils.show('필수 정보를 입력해주세요.', FORM_TOAST_OPTIONS);
        }
    };
    // 유효성 검사 및 첫 번째 에러 키 반환
    const validateAndGetError = () => {
        if (!selectedOption) {
            return 'floorOption';
        }
        if (selectedOption === 'standalone' && selectedStandaloneType === null) {
            return 'standaloneType';
        }
        return null;
    };
    // 다음 버튼 핸들러
    const handleNext = () => {
        const errorKey = validateAndGetError();
        if (errorKey) {
            noticeError(errorKey);
            return;
        }
        onNext();
    };
    return (_jsxs(_Fragment, { children: [_jsx(ScrollView, { children: _jsxs(SafeAreaWrapper, { edges: ['bottom'], children: [_jsx(PlaceInfoSection, { target: "place", name: place.name, address: place.address }), _jsx(SectionSeparator, {}), _jsx(Container, { children: _jsxs(View, { style: { gap: 20 }, children: [_jsxs(QuestionSection, { children: [_jsx(SectionLabel, { children: "\uCE35\uC815\uBCF4" }), _jsxs(QuestionText, { children: [place.name, '은\n건물의 1층에 있나요?'] })] }), _jsx(FloorQuestionUI, { floorOption: selectedOption, selectedFloor: selectedFloor, standaloneType: selectedStandaloneType, onChangeFloorOption: value => form.setValue('floorOption', value), onChangeSelectedFloor: value => form.setValue('selectedFloor', value), onChangeStandaloneType: value => form.setValue('standaloneType', value) })] }) })] }) }), _jsx(SafeAreaWrapper, { edges: ['bottom'], children: _jsx(SubmitButtonWrapper, { children: _jsx(ButtonContainer, { children: _jsx(SccButton, { text: "\uB2E4\uC74C", onPress: handleNext, buttonColor: "brandColor", elementName: "place_form_v2_next", fontFamily: font.pretendardSemibold, style: { borderRadius: 12 } }) }) }) })] }));
}
const Container = styled.View `
  padding-top: 30px;
  padding-horizontal: 20px;
  padding-bottom: 40px;
  gap: 40px;
`;
const ButtonContainer = styled.View `
  flex: 1;
`;
